import { updateObject } from "../../Utils/Utils";

import {
    TOGGLE_DARK_MODE
} from "../Action/ThemeAction";

const initialState = {
    darkMode: localStorage.getItem('dark-mode') ? true : false
}

const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_DARK_MODE:
            return updateObject(state, {
                darkMode: action.mode
            });
        default:
            return state;
    }
}

export default AuthReducer;